import { Component, DoCheck, OnInit, ViewChild } from '@angular/core';
import { Popover } from 'primeng/popover';
import { getEventsByTab, getServiceCodesByTab, TaskBankFilterOption } from 'src/app/shared/entity/indicator.const';
import { TaskBankFilterStateService } from 'src/app/shared/services/task-bank-filter/task-bank-filter-state.service';
import { TaskInfoService } from 'src/app/shared/services/task-info/task-info.service';

@Component({
    selector: 'app-task-bank-filter',
    templateUrl: './task-bank-filter.component.html',
    styleUrls: ['./task-bank-filter.component.scss'],
    standalone: false
})
export class TaskBankFilterComponent implements OnInit, DoCheck {
  @ViewChild('taskBankFilterPanel') taskBankFilterPanel: Popover;
  selectedServiceCode: string | null = null;
  selectedEvent: string | null = null;
  serviceCodeFilter: TaskBankFilterOption[] = [];
  eventsFilter: TaskBankFilterOption[] = [];
  hasServiceCodeFilter = false;
  hasEventsFilter = false;
  hasAnyFilterOptions = false;
  private activeTabLabel = '';

  constructor(
    private readonly taskInfoService: TaskInfoService,
    private readonly taskBankFilterStateService: TaskBankFilterStateService
  ) {}

  ngOnInit(): void {
    this.refreshFilterOptions();
  }

  ngDoCheck(): void {
    const currentTabLabel = this.taskInfoService.activeIndex?.label ?? '';
    if (this.activeTabLabel !== currentTabLabel) {
      this.activeTabLabel = currentTabLabel;
      this.refreshFilterOptions();
      this.clearAll();
    }
  }

  toggle(event: Event) {
    this.refreshFilterOptions();
    this.taskBankFilterPanel.toggle(event);
  }

  onServiceCodeChange(selectedServiceCode: string | null): void {
    this.selectedServiceCode = selectedServiceCode;
    this.publishFilterState();
  }

  onEventChange(selectedEvent: string | null): void {
    this.selectedEvent = selectedEvent;
    this.publishFilterState();
  }

  clearAll(): void {
    this.selectedServiceCode = null;
    this.selectedEvent = null;
    this.publishFilterState();
  }

  private refreshFilterOptions(): void {
    const currentTabLabel = this.taskInfoService.activeIndex?.label;
    this.serviceCodeFilter = getServiceCodesByTab(currentTabLabel);
    this.eventsFilter = getEventsByTab(currentTabLabel);

    this.hasServiceCodeFilter = this.serviceCodeFilter.length > 0;
    this.hasEventsFilter = this.eventsFilter.length > 0;
    this.hasAnyFilterOptions = this.hasServiceCodeFilter || this.hasEventsFilter;

    if (!this.serviceCodeFilter.some((item) => item.key === this.selectedServiceCode)) {
      this.selectedServiceCode = null;
    }

    if (!this.eventsFilter.some((item) => item.key === this.selectedEvent)) {
      this.selectedEvent = null;
    }

    this.publishFilterState();
  }

  private publishFilterState(): void {
    const tabLabel = this.taskInfoService.activeIndex?.label ?? '';
    this.taskBankFilterStateService.updateFilterState({
      serviceCodeKey: this.selectedServiceCode,
      eventKey: this.selectedEvent,
      tabLabel,
    });
  }
}
